import React, { useEffect, useState } from 'react'
import Breadcrumb from '../../../Components/Breadcrumbs'
import { Box, Divider, Grid, Typography } from '@material-ui/core'
import { useStyles } from './style'
import { Link } from 'react-router-dom'
import _ from 'lodash'
import { useScrollSpy } from '../../../Components/CustomHooks'
import { IQBATTRIES, IQMICROINVERTERS, ENPHASEEVSES, THIRDPARTYEVSES, THIRDPARTYHPS } from './constant'

const items = [
  { hash: IQBATTRIES },
  { hash: IQMICROINVERTERS },
  { hash: ENPHASEEVSES },
  { hash: THIRDPARTYEVSES },
  { hash: THIRDPARTYHPS }
]

function ProductLimitations() {
  const classes = useStyles()
  const [active, setActive] = useState(window.location.hash.replace('#', ''))
  const activeSection = useScrollSpy({ items })

  const selectSection = (id) => {
    if (document.getElementById(id)) {
      document.getElementById(id).scrollIntoView({ behavior: "smooth" })
    }
  }

  useEffect(() => {
    if (activeSection) {
      setActive(activeSection)
    }
  }, [activeSection])

  useEffect(() => {
    if (active) {
      selectSection(active)
    }
  }, [])

  return (
    <>
      <Breadcrumb value={[{ 'Developer Hub': '/developer' }, { 'Product Limitations': '/developer/product-limitations' }]} />
      <Box className={classes.headerWrapper}>
        <Typography className={classes.title}>Product Limitations</Typography>
        <Box className={classes.subTitle}>Enphase Product Limitations (and IF APPLICABLE Third-Party Product Limitations)</Box>
      </Box>
      <Box className={classes.cardWrapper}>
        <Grid container spacing={4}>
          <Grid item xs={10}>
            <Box className={classes.cardContent} id='scrollspy'>
              <Typography className={classes.cardTitle}>Enphase Product Limitations</Typography>
              <Box className={classes.subCard} id={IQBATTRIES}>
                <Box display="flex" alignItems="center" px={2} pt={3} pb={2}>
                  <Box className={classes.subCardTitle} mx={1}>
                    IQ Batteries
                  </Box>
                </Box>
                <Box mb={1}>
                  <Divider style={{ color: '#E1E1E1' }} />
                </Box>
                <Box className={classes.subCardContent}>
                  <ol>
                    <li className={classes.listItem}>If Participant’s site has or will implement Power Export Limits (PEL) or Power Control Systems (PCS) in connection with solar energy systems or the Enphase Products, these systems and Enphase Products may not be eligible to participate in the Program or the Enphase Products ability to discharge may be limited.</li>
                    <li className={classes.listItem}>Program results may vary if the Participant engages StormGuard mode during a Dispatch Period (defined below), loses internet connection, or attempts to override or interfere with the instructions.</li>
                    <li className={classes.listItem}>Enphase requires a minimum battery reserve level of up to 10% in some battery and microinverter configurations.</li>
                    <li className={classes.listItem}>An ethernet connection or robust Wi-Fi connection is required</li>
                  </ol>
                </Box>
              </Box>
              <Box className={classes.subCard} id={IQMICROINVERTERS}>
                <Box display="flex" alignItems="center" px={2} pt={3} pb={2}>
                  <Box className={classes.subCardTitle} mx={1}>
                    IQ Microinverters
                  </Box>
                </Box>
                <Box mb={1}>
                  <Divider style={{ color: '#E1E1E1' }} />
                </Box>
                <Box className={classes.subCardContent}>
                  <ol>
                    <li className={classes.listItem}>Supported models are IQ7 and newer</li>
                    <li className={classes.listItem}>A production meter is required for limiting and shutdown of solar production (solar curtailment)</li>
                    <li className={classes.listItem}>A consumption meter and production meter are required for limiting and shutdown of solar exportation (power export limit)</li>
                    <li className={classes.listItem}>Limiting and shutdown of solar exportation (power export limit) is not supported on sites with multiple IQ Gateways</li>
                    <li className={classes.listItem}>In case of powerline communications (PLC) interference, API command execution may be delayed and PLC filter may be required</li>
                    <li className={classes.listItem}>An ethernet connection or robust Wi-Fi connection is required</li>
                  </ol>
                </Box>
              </Box>
              <Box className={classes.subCard} id={ENPHASEEVSES}>
                <Box display="flex" alignItems="center" px={2} pt={3} pb={2}>
                  <Box className={classes.subCardTitle} mx={1}>
                    Enphase EVSEs
                  </Box>
                </Box>
                <Box mb={1}>
                  <Divider style={{ color: '#E1E1E1' }} />
                </Box>
                <Box className={classes.subCardContent}>
                  <ol>
                    <li className={classes.listItem}>If Participant’s site has or will implement Power Export Limits (PEL) or Power Control Systems (PCS) in connection with solar energy systems or the Enphase Products, these systems and Enphase Products may not be eligible to participate in the Program or the Enphase Products ability to discharge may be limited.</li>
                    <li className={classes.listItem}>Program results may vary if the Participant engages StormGuard mode during a Dispatch Period (defined below), loses internet connection, or attempts to override or interfere with the instructions.</li>
                    <li className={classes.listItem}>For IQ EV Charger - For the input charge level, Enphase EVSEs will only accept values at 0%, 25%, 50%, 75%, and 100% of the Enphase EVSE’s power rating</li>
                    <li className={classes.listItem}>For IQ EV Charger 2 - For the input charger level, Enphase IQ EV Charger 2 will only accept values of 0A and between 6A to 32A at increments of 1A. This value may also be restricted by the max allowed charging current limit put by installer at the time of commissioning.</li>
                    <li className={classes.listItem}>Charging power setpoints are issued to the EVSEs in watts, the EVSE will follow the setpoints along its abilities. The deviation from the power setpoint depends on the make and model of the EVSE. Deviations will be in the range of 50 – 900 watts from the issued power setpoint.</li>
                    <li className={classes.listItem}>EVSEs depend in their spectrum of possible power values on the number of phases they are connected to the power grid. The valid power range for single phase EVSEs is 1.4 kW – 7.2 kW. The valid power range for three-phase EVSEs is 4.2 kW – 22 kW.</li>
                    <li className={classes.listItem}>The realizable power values are limited by the ability of the EV to react and the settings active on it.</li>
                    <li className={classes.listItem}>An ethernet connection or robust Wi-Fi connection is required (IQ EV Charger is limited to Wi-Fi connections)</li>
                  </ol>
                </Box>
              </Box>
              <Box className={classes.subCard} id={THIRDPARTYEVSES}>
                <Box display="flex" alignItems="center" px={2} pt={3} pb={2}>
                  <Box className={classes.subCardTitle} mx={1}>
                    Third-Party EVSEs
                  </Box>
                </Box>
                <Box mb={1}>
                  <Divider style={{ color: '#E1E1E1' }} />
                </Box>
                <Box className={classes.subCardContent}>
                  <ol>
                    <li className={classes.listItem}>List of compatible third-party <Box className={classes.link} onClick={() => { window.open('https://enphase.com/installers/iq-energy-management/iq-energy-router/ev-charger', '_blank') }} component="span">EVSEs</Box></li>
                    <li className={classes.listItem}>Must have an Enphase IQ Energy Router installed</li>
                    <li className={classes.listItem}>An ethernet connection or robust Wi-Fi connection is required</li>
                    <li className={classes.listItem}>Charging power setpoints are issued to the EVSEs in watts, the EVSE will follow the setpoints along its abilities. The deviation from the power setpoint depends on the make and model of the EVSE. Deviations will be in the range of 50 – 900 watts from the issued power setpoint.</li>
                    <li className={classes.listItem}>In order to have power setpoints closer to the desired value, please consider setpoints at the full 1 amp increment in the range of 6 – 32 A per phase, similar to the Enphase IQ EV Charger 2.</li>
                    <li className={classes.listItem}>EVSEs depend in their spectrum of possible power values on the number of phases they are connected to the power grid. The valid power range for single phase EVSEs is 1.4 kW – 7.2 kW. The valid power range for three-phase EVSEs is 4.2 kW – 22 kW.</li>
                    <li className={classes.listItem}>The realizable power values are limited by the ability of the EV to react and the settings active on it.</li>
                  </ol>
                </Box>
              </Box>
              <Box className={classes.subCard} id={THIRDPARTYHPS}>
                <Box display="flex" alignItems="center" px={2} pt={3} pb={2}>
                  <Box className={classes.subCardTitle} mx={1}>
                    Third-Party HPs
                  </Box>
                </Box>
                <Box mb={1}>
                  <Divider style={{ color: '#E1E1E1' }} />
                </Box>
                <Box className={classes.subCardContent}>
                  <ol>
                    <li className={classes.listItem}>List of compatible third-party  <Box className={classes.link} onClick={() => { window.open('https://enphase.com/installers/iq-energy-management/iq-energy-router/heat-pump', '_blank') }} component="span">HPs</Box></li>
                    <li className={classes.listItem}>Must have an Enphase IQ Energy Router installed</li>
                    <li className={classes.listItem}>An ethernet connection or robust Wi-Fi connection is required</li>
                    <li className={classes.listItem}>SG Ready modes have inherent limitations that are driven by the current state of the HP. The response in terms of power changes will always be site-specific and requires a site-specific analysis of the response characteristics.</li>
                    <li className={classes.listItem}>SG Ready Mode 1 (forced off) can be triggered and will force a HP to switch off for a defined amount of time (usually max. 2 hours), given that it was on when the command is issued. If the HP was not on, there will be no reaction to this command.</li>
                    <li className={classes.listItem}>SG Ready Mode 2 (normal operation) is a normal operation and will not trigger any direct change of behavior, unless, for example, the HP was in a forced off state.</li>
                    <li className={classes.listItem}>SG Ready Mode 3 (recommended on) will trigger the HP if it has enough thermal flexibility to react to this command. There is no guarantee that the HP will react to this command and response will be site-specific.</li>
                    <li className={classes.listItem}>SG Ready Mode 4 (forced on) will trigger the HP in any case, if possible. The duration of the response depends on the maximum heat storage capacity and the ability to overheat the premise. The extent and the duration of the response are also site-specific.</li>
                  </ol>
                </Box>
              </Box>
            </Box>
          </Grid>
          <Grid item xs={2}>
            <Box className={classes.scrollSpyContainer}>
              <>
                <Box className={classes.scrollSpyListText} pb={0.5}><b>On this page</b></Box>
                <Box id={IQBATTRIES} py={1} pl={0.5} onClick={() => { setActive(IQBATTRIES); selectSection(IQBATTRIES) }} className={`${active === IQBATTRIES ? classes.currentSection : ''}`}><Link className={classes.scrollSpyListText} to={{ pathname: '/developer/product-limitations', hash: `#${IQBATTRIES}` }} replace>IQ Batteries</Link></Box>
                <Box id={IQMICROINVERTERS} py={1} pl={0.5} onClick={() => { setActive(IQMICROINVERTERS); selectSection(IQMICROINVERTERS) }} className={`${active === IQMICROINVERTERS ? classes.currentSection : ''}`}><Link className={classes.scrollSpyListText} to={{ pathname: '/developer/product-limitations', hash: `#${IQMICROINVERTERS}` }} replace>IQ Microinverters</Link></Box>
                <Box id={ENPHASEEVSES} py={1} pl={0.5} onClick={() => { setActive(ENPHASEEVSES); selectSection(ENPHASEEVSES) }} className={`${active === ENPHASEEVSES ? classes.currentSection : ''}`}><Link className={classes.scrollSpyListText} to={{ pathname: '/developer/product-limitations', hash: `#${ENPHASEEVSES}` }} replace>Enphase EVSEs</Link></Box>
                <Box id={THIRDPARTYEVSES} py={1} pl={0.5} onClick={() => { setActive(THIRDPARTYEVSES); selectSection(THIRDPARTYEVSES) }} className={`${active === THIRDPARTYEVSES ? classes.currentSection : ''}`}><Link className={classes.scrollSpyListText} to={{ pathname: '/developer/product-limitations', hash: `#${THIRDPARTYEVSES}` }} replace>Third Party EVSEs</Link></Box>
                <Box id={THIRDPARTYHPS} py={1} pl={0.5} onClick={() => { setActive(THIRDPARTYHPS); selectSection(THIRDPARTYHPS) }} className={`${active === THIRDPARTYHPS ? classes.currentSection : ''}`}><Link className={classes.scrollSpyListText} to={{ pathname: '/developer/product-limitations', hash: `#${THIRDPARTYHPS}` }} replace>Third Party HPs</Link></Box>
              </>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  )
}

export default ProductLimitations
